import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-[#1A2E1A] text-background-50/80">
      <div className="px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">Superbuy Sheet</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              Your smart shopping companion. Browse 14 curated product categories with organized spreadsheets for faster global sourcing.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/50 mb-5">Subscribe</h4>
            <div className="flex items-center border-b border-background-50/20 pb-2">
              <input
                type="email"
                placeholder="Your email"
                className="bg-transparent text-sm text-background-50 placeholder-background-50/30 outline-none flex-1"
              />
              <button className="w-8 h-8 flex items-center justify-center text-background-50/60 hover:text-background-50 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="text-xs text-background-50/30 mt-2">
              Get the latest sheets &amp; deals
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/50 mb-5">Categories</h4>
            <div className="grid grid-cols-2 gap-1.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50/50 mb-5">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Home</Link>
              <Link to="/article/superbuy-sheet-beginner-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Beginner Guide</Link>
              <Link to="/article/superbuy-sheet-qc-checklist" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">QC Checklist</Link>
              <Link to="/article/superbuy-sheet-shipping-tips" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Shipping Tips</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Main Store</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 py-8 px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/30">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">Main Store</a>
            <Link to="/article/superbuy-sheet-beginner-guide" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">Guide</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}